import React from 'react';

const ReferenceLabel = ({
  fill, value, textAnchor, fontSize, viewBox, dy, dx
}) => {
  const x = viewBox.width + viewBox.x + 5;
  const y = viewBox.y + 4;

  return (
    <text
      x={x}
      y={y}
      dy={dy}
      dx={dx}
      fill={fill}
      fontSize={fontSize || 10}
      textAnchor={textAnchor}
      className='recharts-text recharts-label'
    >
      <tspan>
        {value}
      </tspan>
    </text>
  );
};

export default ReferenceLabel;



// WEBPACK FOOTER //
// ./src/components/common/chart/reference-label.jsx